export const ALL_LOYALTY_TIER = 'ALL';
export const WEDDING_REGISTRY = 'WEDDING_REGISTRY';

export const TIER_NAMES = {
  GOLD: 'gold',
  PLATINUM: 'platinum',
  NON_LOYALIST: 'non-loyalist',
};

/**
 * @param {Badge} badge
 * @param {UserData} userData
 * @returns {boolean}
 */
const _validateLoyaltyEligibleTier = (badge, userData) => {
  const {
    shoppingMode,
    user,
    tierName,
  } = userData;

  if (tierName === TIER_NAMES.NON_LOYALIST) return false;

  const { loyaltyEligibleTier } = badge;

  return (
    (user?.isSignedIn || user?.isSoftSignedIn)
    && loyaltyEligibleTier && (loyaltyEligibleTier === tierName || loyaltyEligibleTier === ALL_LOYALTY_TIER)
    && shoppingMode !== WEDDING_REGISTRY
  );
};

/**
 *
 * @param {UserData} userData
 * @returns {boolean}
 */
const _validateFreeShippingPromotion = (userData) => {
  const {
    user,
    tierName,
  } = userData;

  let result = true;
  const signedIn = user?.isSignedIn || user?.isSoftSignedIn;
  if (signedIn) {
    result = !(tierName === TIER_NAMES.GOLD || tierName === TIER_NAMES.PLATINUM);
  }
  return result;
};

/**
 * Updating product badges based on userData.
 * Should be evoked on client side
 * @param {BadgesList} badges
 * @param {UserData} userData
 * @returns {BadgesList}
 */
export const updateActiveBadges = (badges, userData) => {
  const { tierName } = userData;

  return badges.map((badge) => {
    let active = true;
    if (badge.loyaltyEligibleTier) {
      active = _validateLoyaltyEligibleTier(badge, userData);
    } else if (badge.promotionType === 'Free Shipping') {
      active = _validateFreeShippingPromotion(userData);
    }

    return {
      ...badge,
      active,
      validateOnClient: false,
      tierIconClass: (tierName || '').toLowerCase(),
    };
  });
};

export default updateActiveBadges;
